import { Sheet } from '@gravity-ui/uikit';
import { useState } from 'react';
import type { Estimate, Problem } from 'store/types/common';
import { ClientBlankEstimateBlock } from './client-blank-estimate-block';
import { ProblemSheetContent } from './blank-problem-sheet-content';

import styles from './styles.module.scss';

export interface ClientBlankEstimateListProps {
	data: Data;
}

export interface Data {
	problems: Problem[];
	estimate?: Estimate[];
}

export type SheetType = 'execution' | 'satisfaction' | null;

export const ClientBlankEstimateList = ({ data }: ClientBlankEstimateListProps) => {
	const [sheetVisible, setSheetVisible] = useState(false);
	const [sheetType, setSheetType] = useState<SheetType>(null);
	const [selectedProblem, setSelectedProblem] = useState<Problem | null>(null);

	const problems = data.problems;
	const groups = problems.reduce<Record<string, Problem[]>>((acc, problem) => {
		const groupName = problem.parentSectionName;
		if (!acc[groupName]) {
			acc[groupName] = [];
		}
		acc[groupName].push(problem);
		return acc;
	}, {});

	const sectionNames = Object.keys(groups);
	let sheetTitle = '';

	const handleOpenSheet = (problem: Problem, type: SheetType) => {
		setSelectedProblem(problem);
		setSheetType(type);
		setSheetVisible(true);
	};

	const handleCloseSheet = () => {
		setSheetVisible(false);
		setSheetType(null);
		setSelectedProblem(null);
	};

	return (
		<div className={styles.estimate_container}>
			{sectionNames.map((sectionName) => (
				<div key={sectionName} className={styles.estimate_container__section_group}>
					<div className={styles.estimate_container__section_group__title}>
						<span>Раздел</span>
						<h3>{sectionName}</h3>
					</div>
					<div className={styles.estimate_container__section_group__problems}>
						{groups[sectionName].map((problem) => (
							<ClientBlankEstimateBlock problem={problem} handleOpenSheet={handleOpenSheet} />
						))}
					</div>
				</div>
			))}
			<Sheet visible={sheetVisible} onClose={handleCloseSheet} title={sheetTitle} className={styles.sheet}>
				{selectedProblem && sheetType && (
					<ProblemSheetContent problem={selectedProblem} sheetType={sheetType} />
				)}
			</Sheet>
		</div>
	);
};
